export const CurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    GBP: 'GBP',
    ZAR: 'ZAR',
};
export const stringToCurrency = (isoCode) => {
    if (!isoCode) {
        return CurrencyEnum.EUR;
    }
    return (Object.values(CurrencyEnum).find((currency) => currency.toLowerCase() === isoCode.toLowerCase()) ?? CurrencyEnum.EUR);
};
export const createPriceObject = (amount, currency) => {
    return {
        amount,
        currency,
    };
};
export const formatPriceString = (amount, currency = 'EUR', locale = 'nl-NL') => {
    if (amount === null || amount === undefined) {
        return undefined;
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(typeof amount === 'string' ? Number(amount) : amount);
};
//# sourceMappingURL=currency.js.map